import { toast, Flip } from "react-toastify";
import { useNavigate } from "react-router-dom";
import api from "../../../../../../features/auth/axiosConfig";

interface SaveCartParams {
  condition: number;
  dis_value: number;
  totalAmount: number;
  totalQuantity: number;
  deliveryFee: number;
  selectedProductslist: any[];
  valueMap: { [key: string]: number };
  setCartId: (id: string) => void;
}

export const useCartSave = ({ condition, dis_value, totalAmount, totalQuantity, deliveryFee, selectedProductslist, valueMap, setCartId }: SaveCartParams) => {
  const navigation = useNavigate();

  const Savecart = async (checkout: string | null) => {
    if (totalAmount <= 0) {
      toast.warn("Please select at least one product", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
        transition: Flip,
      });
      return;
    }

    const currentDate = new Date();
    const cartId = `${String(currentDate.getMonth() + 1).padStart(2, "0")}${String(currentDate.getDate()).padStart(2, "0")}${String(currentDate.getHours()).padStart(2, "0")}${String(
      currentDate.getMinutes()
    ).padStart(2, "0")}${String(currentDate.getSeconds()).padStart(2, "0")}`;

    const orderData = {
      discount: condition,
      totalPrice: dis_value,
      products: selectedProductslist.map((product) => ({
        productId: product._id.$oid,
        productName: product.ProductName,
        amount: Number(product.Amount),
        arabicword: product.ArabicName,
        quantity: Number(valueMap[`${product._id.$oid}-${product.Amount}`] || 1),
        totalPrice: Number(valueMap[`${product._id.$oid}-${product.Amount}`] || 1) * parseFloat(product.Amount),
      })),
      totalAmount,
      deliveryFee,
      Finalamount: dis_value || totalAmount + deliveryFee,
      totalQuantity,
      cartId,
    };

    try {
      const res = await api.post(`/app/v1/pos/shopping_cart`, orderData, {
        headers: { "Content-Type": "application/json" },
      });
      setCartId(res.data._id);

      if (!checkout) {
        navigation(`/v1/cart/${res.data._id}`);
      }
    } catch (error) {
      console.error("Error saving cart:", error);
    }
  };

  return Savecart;
};
